'use client';

import React, { ReactNode } from 'react';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import styles from './SideHero.module.scss';

export type HeroProps = {
  imageSrc: string;
  imageAlt?: string;
  title: ReactNode;
};

type SideHeroProps = {
  hero: HeroProps;
  objectFit?: 'cover' | 'contain';
  fillHeight?: boolean;
};

export default function SideHero({ hero, objectFit = 'contain', fillHeight = true }: SideHeroProps) {
  const t = useTranslations('Login');

  return (
    <div className={styles.heroBox}>
      <Image
        src={hero.imageSrc}
        alt={hero.imageAlt || t('Hero image')}
        style={{
          objectFit,
          height: fillHeight ? '100%' : 'auto',
          width: 'auto',
        }}
        width={0}
        height={0}
        sizes='100vh'
        priority
      />
      <div className={styles.overlay}>
        <h2 className={styles.overlayTitle}>
          {hero.title}
        </h2>
      </div>
    </div>
  );
}
